import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';
import { Text } from '../text/Text.js';

var AttributeLabel = /*#__PURE__*/styled(Text).withConfig({
  displayName: "IconLabel__AttributeLabel",
  componentId: "sc-1wdkxxb-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-transform: uppercase;\n  font-size: 1em;\n  font-weight: 500;\n  color: ", ";\n  margin-left: 0.5em;\n  line-height: 1;\n"], ["\n  text-transform: uppercase;\n  font-size: 1em;\n  font-weight: 500;\n  color: ", ";\n  margin-left: 0.5em;\n  line-height: 1;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.text.normal;
});
var Container = /*#__PURE__*/styled(Box).withConfig({
  displayName: "IconLabel__Container",
  componentId: "sc-1wdkxxb-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  align-items: center;\n"])));
var IconLabel = function (_a) {
  var label = _a.label,
    icon = _a.icon,
    _b = _a.color,
    color = _b === void 0 ? "primary" : _b,
    _c = _a.fontSize,
    fontSize = _c === void 0 ? "10px" : _c,
    _d = _a.iconSize,
    iconSize = _d === void 0 ? "1.2em" : _d,
    rest = __rest(_a, ["label", "icon", "color", "fontSize", "iconSize"]);
  return React__default.createElement(Container, __assign({
    color: color,
    fontSize: fontSize
  }, rest), React__default.cloneElement(icon, {
    size: iconSize
  }), React__default.createElement(AttributeLabel, {
    letterSpacing: "wide"
  }, label));
};
var templateObject_1, templateObject_2;

export { IconLabel };
//# sourceMappingURL=IconLabel.js.map
